import React, { Fragment } from 'react';

import Header from '../components/Header/Header';

const layout = props => (
    <Fragment>
        <Header />
        {props.children}
    </Fragment>
);

export default layout;